import { render } from "./titleNavBar.vue?vue&type=template&id=6dab0881"
import script from "./titleNavBar.vue?vue&type=script&lang=js"
export * from "./titleNavBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__